import { render, staticRenderFns } from "./DishStatistics.vue?vue&type=template&id=a1b4980c&scoped=true"
import script from "./DishStatistics.vue?vue&type=script&lang=js"
export * from "./DishStatistics.vue?vue&type=script&lang=js"
import style0 from "./DishStatistics.vue?vue&type=style&index=0&id=a1b4980c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b4980c",
  null
  
)

export default component.exports